import React from 'react';
import { useState, useEffect } from 'react';
import { collection, doc, query, where, getDocs, setDoc } from 'firebase/firestore';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { firestore, storage } from '../../../../config/firebase';
import { Button, Col, Form, Image, Input, Modal, Progress, Row, Space, Tooltip, message } from 'antd';
import { DeleteOutlined, EditOutlined } from "@ant-design/icons"
const initialState = { title: "", category: "", description: "" }

export default function AdminBlog() {
  const [state, setState] = useState(initialState);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenForUpdate, setIsModalOpenForUpdate] = useState(false);
  const [blogsData, setBlogsData] = useState([]);
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);

  const truncateStringTo10Words = (inputString) => {
    const words = inputString.split(' ');
    const truncatedString = words.slice(0, 10).join(' ');
    return truncatedString + ' . . . .';
  };

  const handleChange = (e) => {
    setState((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
  };

  const uploadFile = async (file, blogId) => {
    if (file.size > 60 * 1024) {
      message.error('File size should be smaller than 60 KB');
      return;
    }
  
    const fileName = blogId;
    const fileExtension = file.name.split('.').pop();
    const storageRef = ref(storage, `images/${fileName}.${fileExtension}`);
    const uploadTask = uploadBytesResumable(storageRef, file);
  
    try {
      await new Promise((resolve, reject) => {
        uploadTask.on(
          'state_changed',
          (snapshot) => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setProgress(Math.floor(progress));
          },
          (error) => {
            reject(error);
          },
          () => {
            resolve(uploadTask.snapshot.ref);
          }
        );
      });
  
      const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
      return downloadURL;
    } catch (error) {
      message.error('Error uploading or getting download URL');
      throw error;
    }
  };
  
  const addBlogToFirestore = async (blogData) => {
    try {
      await setDoc(doc(firestore, 'blogs', blogData.blogId), blogData);
      setBlogsData([blogData, ...blogsData]);
      message.success('The Blog Added successfully');
      setIsModalOpen(false);
    } catch (error) {
      console.error('Error adding document: ', error);
    }
  };
  
  const handleUpdateBlog = async () => {
    try {
      if (file) {
        const fileURL = await uploadFile(file, state.blogId);
        setState({ ...state, fileURL }); 
      }
  
      const updatedBlogsData = blogsData.map((blog) => {
        if (blog.blogId === state.blogId) {
          return { ...blog, ...state };
        }
        return blog;
      });
      await setDoc(doc(firestore, 'blogs', state.blogId), state);
      setBlogsData(updatedBlogsData);
      message.success('The Blog Updated successfully');
      setIsModalOpenForUpdate(false);
    } catch (error) {
      console.error('Error updating document: ', error);
    }
  };
  
  const handleAddBlog = () => {
    const blogId = Math.random().toString(36).slice(2);
  
    if (file) {
      uploadFile(file, blogId)
        .then((fileURL) => {
          const blogData = {
            ...state,
            createdAt: new Date().toLocaleString(),
            blogId,
            fileURL,
            status: 'active',
          };
  
          if (!blogData.title || !blogData.category || !blogData.description || !blogData.fileURL) {
            message.error('FILL ALL INPUTS');
            return;
          }
  
          addBlogToFirestore(blogData);
        })
        .catch((error) => {
          console.error('Error handling file upload: ', error);
        });
    } else {
      message.error('Please select a file.');
    }
  };
  
  const deleteBlog = async (blog) => {
    let deletedBlog = { ...blog, status: "deleted" }
    try {
      await setDoc(doc(firestore, "blogs", deletedBlog.blogId), deletedBlog);
      let blogsDataAfterDelete = blogsData.filter((blog) => blog.blogId !== deletedBlog.blogId)
      setBlogsData(blogsDataAfterDelete)
      message.success("The Blog Deleted successfully")
    } catch (e) {
      console.error("Error adding document: ", e);
    }
  }
  useEffect(() => {
    // Fetch blogs data from Firestore when component mounts
    const getBlogsFromFirestore = async () => {
      const q = query(collection(firestore, 'blogs'), where('status', '==', 'active'));
      const querySnapshot = await getDocs(q);
      const array = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        array.push(data);
      });
      setBlogsData(array);
    };

    getBlogsFromFirestore();
  }, []);
  return (
    <>
      <h1 className=' text-[#fffa8a] pt-24 font-bold text-[48px] text-center italic'>All Blogs Table</h1>
      <div className="flex justify-content-center  mt-5">
        <Button
          
          className="px-10  text-center rounded-2xl mx-auto  hover:rounded-lg"
          style={{ background: "transparent", border: "1px solid #fffa8a", color: "#fffa8a" }} onClick={() => setIsModalOpen(true)}
        >
          Add Blog
        </Button></div>
      <div className="container max-w-[90%] text-[#fffa8a] px-4 mx-auto sm:px-8"  style={{ background: "transparent" }}>
        <div className="py-8">
          <div className="px-4 py-4 -mx-4 overflow-x-auto sm:-mx-8 sm:px-8">
            <div className="inline-block min-w-full overflow-hidden rounded-lg shadow">
              <table className="min-w-full leading-normal" >
                <thead>
                  <tr>
                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                      Title
                    </th>
                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                      Category
                    </th>
                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                      Created at
                    </th>
                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                      Description
                    </th>
                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {blogsData.map((rowData, index) => (
                    <tr key={index}>
                      <td className="px-5 py-5 text-sm  border-b text-left border-[#fffa8a] text-[#fffa8a]">
                        <div className="flex items-center">
                          <div>
                            <p className=" whitespace-no-wrap">{rowData.title}</p>
                          </div>
                        </div>
                      </td>
                      <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                        <p className=" whitespace-no-wrap">{rowData.category}</p>
                      </td>
                      <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                        <p className=" whitespace-no-wrap">{rowData.createdAt}</p>
                      </td>
                      <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                        {truncateStringTo10Words(rowData.description)}
                      </td>
                      <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                        <Space>
                          <Tooltip title="Delete" color='red'  ><Button onClick={() => deleteBlog(rowData)} danger icon={<DeleteOutlined />} /></Tooltip>
                          <Tooltip title="Edit"  ><Button type="primary" icon={<EditOutlined className='text-[#fffa8a]' onClick={() => {
                            setIsModalOpenForUpdate(true)
                            setState(rowData)
                          }} />} /></Tooltip>
                        </Space>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      );
      <Modal
        title="ADD BLOG"
        centered
        open={isModalOpen}
        onOk={handleAddBlog}
        okText="Confirm"
        okButtonProps={{ type: 'primary', color: "primary", className: ' text-center rounded-2xl text-black   hover:rounded-lg ' }}
        cancelText="Close"
        onCancel={() => setIsModalOpen(false)}
        style={{ maxWidth: 1000 }}
      >
        <Form layout="vertical" className='py-4'>
          <Row gutter={16}>
            <Col xs={24} lg={8}>
              <Form.Item label="Title">
                <Input placeholder='Input your title' name='title' onChange={handleChange} />
              </Form.Item>
            </Col>
            <Col xs={24} lg={8}>
              <Form.Item label="Category">
                <Input placeholder='Enter the Category' name='category' onChange={handleChange} />
              </Form.Item>
            </Col>
            <Col xs={12} lg={12}>
              <Form.Item label="Image">
                <Input type='file' placeholder='Upload picture' onChange={e => { setFile(e.target.files[0]) }} />
              </Form.Item>
              {file && <Progress percent={progress} showInfo={false} />}
            </Col>
            <Col xs={12} lg={12}>
              <Form.Item label="Preview">
                {file && <Image src={URL.createObjectURL(file)} style={{ width: 50, height: 50 }} />}
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Description" className='mb-0'>
                <Input.TextArea placeholder='Input your description' name='description' onChange={handleChange} />
              </Form.Item>
            </Col>
          </Row>
          <div className="flex justify-content-center">
            <Button onClick={handleAddBlog} className='mx-auto mt-5 text-center'>Add Blog</Button></div>
        </Form>
      </Modal>
      <Modal
        title="Update BLOG"
        centered
        open={isModalOpenForUpdate}
        onOk={handleUpdateBlog}
        okText="Confirm"
        okButtonProps={{ type: 'primary', color: "primary", className: ' text-center rounded-2xl text-black   hover:rounded-lg ' }}
        cancelText="Close"
        onCancel={() => setIsModalOpenForUpdate(false)}
        style={{ maxWidth: 1000 }}
      >
        <Form layout="vertical" className='py-4'>
          <Row gutter={16}>
            <Col xs={24} lg={12}>
              <Form.Item label="Title">
                <Input placeholder='Input your title' name='title' value={state.title} onChange={handleChange} />
              </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item label="Category">
                <Input placeholder='Enter the Category' name='category' value={state.category} onChange={handleChange} />
              </Form.Item>
            </Col>
            <Col xs={12} lg={12}>
              <Form.Item label="Image">
                <Input type='file' placeholder='Upload picture' onChange={e => { setFile(e.target.files[0]) }} />
              </Form.Item>
              {file && <Progress percent={progress} showInfo={false} />}
            </Col>
            <Col xs={12} lg={12}>
              <Form.Item label="Preview">
                {file && <Image src={URL.createObjectURL(file)} style={{ width: 50, height: 50 }} />}
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Description" className='mb-0'>
                <Input.TextArea placeholder='Input your description' value={state.description} name='description' onChange={handleChange} />
              </Form.Item>
            </Col>
          </Row>
          <div className="flex justify-content-center">
            <Button onClick={handleUpdateBlog} className='mx-auto mt-5 text-center'>Update Blog</Button></div>
        </Form>
      </Modal>
    </>
  )
}
